import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Hero from './components/Hero';
import About from './components/About';
import Portfolio from './components/Portfolio';
import Tech from './components/Tech';
import Skills from './components/Skills';
import Experience from './components/Experience';
import Education from './components/Education';
import Contact from './components/Contact';
import Aurora from "./components/Aurora";
import MoreStuff from './components/MoreStuff';
import TelephonyDirectory from './components/TelephonyDirectory';

function Home() {
  return (
      <div className="App">
          <div style={{width: '100%', height: '800px', position: 'absolute'}}>
              <Aurora/>
          </div>
          <div style={{position: 'relative', zIndex: 10}}>
              <Hero/>
              <About/>
              <Tech/>
              <Skills/>
              <Experience/>
              <Education/>
              <Portfolio/>
              <MoreStuff/>
              <Contact/>
          </div>
      </div>
  );
}

function App() {
  return (
      <BrowserRouter>
          <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/telephony" element={
                  <div className="App">
                      <div style={{width: '100%', height: '800px', position: 'absolute'}}>
                          <Aurora/>
                      </div>
                      <div style={{position: 'relative', zIndex: 10}}>
                          <Hero/>
                          <TelephonyDirectory/>
                      </div>
                  </div>
              } />
          </Routes>
      </BrowserRouter>
  );
}

export default App;
